import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { ResidentPicker } from "@/components/nds/windows/resident/ResidentPicker";
import DocumentsTab from "@/components/nds/windows/resident/DocumentsTab";
import { OpenResidentButton } from "@/components/nds/OpenResidentButton";

export default function ReDocumentsContent() {
  const [res, setRes] = useState(null);
  return (
    <div data-testid="re-docs-content" className="h-full overflow-y-auto p-5 space-y-4">
      {res ? (
        <>
          <button type="button" onClick={() => setRes(null)} data-testid="re-docs-back" className="inline-flex items-center gap-1 font-mono text-[10px] tracking-[0.22em] uppercase text-nex-gold"><ArrowLeft className="h-3.5 w-3.5" /> Residents</button>
          <div className="flex items-center gap-3"><h3 data-testid="re-docs-resident" className="text-lg font-semibold text-nex-silver">{res.first_name} {res.last_name}</h3><OpenResidentButton residentId={res.id} name={`${res.first_name} ${res.last_name}`} /></div>
          <DocumentsTab resident={res} manage />
        </>
      ) : <ResidentPicker prefKey="docs" onPick={setRes} testid="re-docs-picker" />}
    </div>
  );
}
